import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { fetchDomainData } from '../actions/app.action';

export const useDomainData = () => {
  const dispatch = useDispatch();
  const { userInfo } = useSelector((state: any) => ({
    userInfo: state.loginResource,
  }));

  useEffect(() => {
    // Fetch domains when profile, company, or project changes
    dispatch(fetchDomainData() as any);
  }, [
    userInfo?.preferredProfile,
    userInfo?.preferredCompany,
    userInfo?.preferredProject,
    dispatch
  ]);
};